import { default as faqRNpUmePkfpMeta } from "/home/runner/work/web/web/apps/web/app/pages/(about)/faq.vue?macro=true";
import { default as create3G7FGKZYRoMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/adopt-me/ads/create.vue?macro=true";
import { default as indexVJGcovbTR6Meta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/adopt-me/ads/index.vue?macro=true";
import { default as calculateZCP1OHYa1bMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/adopt-me/calculate.vue?macro=true";
import { default as indexL0xTFpDGVBMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/adopt-me/index.vue?macro=true";
import { default as itemshy4O9403zTMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/adopt-me/items.vue?macro=true";
import { default as value_45changesfxqDTpBl5dMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/adopt-me/value-changes.vue?macro=true";
import { default as create3UmInPBVVeMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/anime-defenders/ads/create.vue?macro=true";
import { default as index10s7EnNbCUMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/anime-defenders/ads/index.vue?macro=true";
import { default as calculate0j0U03B04IMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/anime-defenders/calculate.vue?macro=true";
import { default as indexQ87O36Ds7YMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/anime-defenders/index.vue?macro=true";
import { default as itemsBBrvtj7ZL0Meta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/anime-defenders/items.vue?macro=true";
import { default as unitsf6eBAMg6RAMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/anime-defenders/units.vue?macro=true";
import { default as value_45changesXch0As2AOTMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/anime-defenders/value-changes.vue?macro=true";
import { default as _91id_93o9HXNKKJOxMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/(items)/emote/[id].vue?macro=true";
import { default as _91id_93r1KcouqxHqMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/(items)/explosion/[id].vue?macro=true";
import { default as _91id_93zb95h4J63ZMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/(items)/sword/[id].vue?macro=true";
import { default as _91id_93dkK0BpZsoIMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/ad/[id].vue?macro=true";
import { default as indexFczA9733v6Meta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/ads/create/index.vue?macro=true";
import { default as index68Qj8H6DkRMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/ads/index.vue?macro=true";
import { default as indexv6p62p2mJxMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/calculate/index.vue?macro=true";
import { default as emotesTWleypDJv7Meta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/emotes.vue?macro=true";
import { default as explosionswVPYX9wuXRMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/explosions.vue?macro=true";
import { default as indexqJVoSL9jZ4Meta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/index.vue?macro=true";
import { default as swordsw15rY13J35Meta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/swords.vue?macro=true";
import { default as value_45changesQ1OjBNoWzQMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/value-changes.vue?macro=true";
import { default as _91id_93PigPIU73M3Meta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/ad/[id].vue?macro=true";
import { default as indexFZK19nq6E3Meta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/ads/create/index.vue?macro=true";
import { default as indexoU7dlo5HLKMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/ads/index.vue?macro=true";
import { default as indexYHK4Hy8wo9Meta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/calculate/index.vue?macro=true";
import { default as indexI0PJCaE04GMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/index.vue?macro=true";
import { default as _91id_93VwD0BLRiwtMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/leak/[id].vue?macro=true";
import { default as leaksvLZ4FR6M29Meta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/leaks.vue?macro=true";
import { default as _91id_93UPOTsvwxJtMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/skin/[id].vue?macro=true";
import { default as skinsd1zbpqWpK4Meta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/skins.vue?macro=true";
import { default as value_45changesc9XSRQ30CoMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/value-changes.vue?macro=true";
import { default as _91id_93NaegHQKTocMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/ad/[id].vue?macro=true";
import { default as indexaEWzgjHMCLMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/ads/create/index.vue?macro=true";
import { default as indexBWfmxmMppGMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/ads/index.vue?macro=true";
import { default as indexXX91YCS6B2Meta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/calculate/index.vue?macro=true";
import { default as indexnHETk2soNUMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/index.vue?macro=true";
import { default as _91id_93UALAIrEaXnMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/item/[id].vue?macro=true";
import { default as itemsBGqtqgFfYfMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/items.vue?macro=true";
import { default as value_45changes5dhTNgMR9SMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/value-changes.vue?macro=true";
import { default as _91id_93pd0Fv1lXXWMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/ad/[id].vue?macro=true";
import { default as indexhUpw0WiqqNMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/ads/create/index.vue?macro=true";
import { default as indexyr4s1PXN6WMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/ads/index.vue?macro=true";
import { default as indexxttxX8BKDdMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/calculate/index.vue?macro=true";
import { default as indexx9eG8BndslMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/index.vue?macro=true";
import { default as _91id_93PEN4hTh2hrMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/item/[id].vue?macro=true";
import { default as items0pmMc4tYaSMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/items.vue?macro=true";
import { default as value_45changesFMEiuvOoOsMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/value-changes.vue?macro=true";
import { default as _91id_93V29tX7DO3PMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/ad/[id].vue?macro=true";
import { default as indexrFJf1iHJdlMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/ads/create/index.vue?macro=true";
import { default as indexL6d5I0asFXMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/ads/index.vue?macro=true";
import { default as indexUwfCfVwryeMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/calculate/index.vue?macro=true";
import { default as indexf6IBugeQd8Meta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/index.vue?macro=true";
import { default as _91id_93Y4dwkxJ1f6Meta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/item/[id].vue?macro=true";
import { default as itemsDaCHNOc7ayMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/items.vue?macro=true";
import { default as value_45changesCcm91HnlEQMeta } from "/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/value-changes.vue?macro=true";
import { default as community_45guidelinesdy2obH0MaIMeta } from "/home/runner/work/web/web/apps/web/app/pages/(legal)/community-guidelines.vue?macro=true";
import { default as privacy_45policyinDBZE3WJmMeta } from "/home/runner/work/web/web/apps/web/app/pages/(legal)/privacy-policy.vue?macro=true";
import { default as terms5Qrcc24WxoMeta } from "/home/runner/work/web/web/apps/web/app/pages/(legal)/terms.vue?macro=true";
import { default as indexI6aHGDWrAdMeta } from "/home/runner/work/web/web/apps/web/app/pages/home/index.vue?macro=true";
import { default as staffFD0hmDLbLsMeta } from "/home/runner/work/web/web/apps/web/app/pages/staff.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(about)/faq.vue")
  },
  {
    name: "adopt-me-ads-create",
    path: "/adopt-me/ads/create",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/adopt-me/ads/create.vue")
  },
  {
    name: "adopt-me-ads",
    path: "/adopt-me/ads",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/adopt-me/ads/index.vue")
  },
  {
    name: "adopt-me-calculate",
    path: "/adopt-me/calculate",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/adopt-me/calculate.vue")
  },
  {
    name: "adopt-me",
    path: "/adopt-me",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/adopt-me/index.vue")
  },
  {
    name: "adopt-me-items",
    path: "/adopt-me/items",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/adopt-me/items.vue")
  },
  {
    name: "adopt-me-value-changes",
    path: "/adopt-me/value-changes",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/adopt-me/value-changes.vue")
  },
  {
    name: "anime-defenders-ads-create",
    path: "/anime-defenders/ads/create",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/anime-defenders/ads/create.vue")
  },
  {
    name: "anime-defenders-ads",
    path: "/anime-defenders/ads",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/anime-defenders/ads/index.vue")
  },
  {
    name: "anime-defenders-calculate",
    path: "/anime-defenders/calculate",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/anime-defenders/calculate.vue")
  },
  {
    name: "anime-defenders",
    path: "/anime-defenders",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/anime-defenders/index.vue")
  },
  {
    name: "anime-defenders-items",
    path: "/anime-defenders/items",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/anime-defenders/items.vue")
  },
  {
    name: "anime-defenders-units",
    path: "/anime-defenders/units",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/anime-defenders/units.vue")
  },
  {
    name: "anime-defenders-value-changes",
    path: "/anime-defenders/value-changes",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/anime-defenders/value-changes.vue")
  },
  {
    name: "bladeball-emote-id",
    path: "/bladeball/emote/:id()",
    meta: _91id_93o9HXNKKJOxMeta || {},
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/(items)/emote/[id].vue")
  },
  {
    name: "bladeball-explosion-id",
    path: "/bladeball/explosion/:id()",
    meta: _91id_93r1KcouqxHqMeta || {},
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/(items)/explosion/[id].vue")
  },
  {
    name: "bladeball-sword-id",
    path: "/bladeball/sword/:id()",
    meta: _91id_93zb95h4J63ZMeta || {},
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/(items)/sword/[id].vue")
  },
  {
    name: "bladeball-ad-id",
    path: "/bladeball/ad/:id()",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/ad/[id].vue")
  },
  {
    name: "bladeball-ads-create",
    path: "/bladeball/ads/create",
    meta: indexFczA9733v6Meta || {},
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/ads/create/index.vue")
  },
  {
    name: "bladeball-ads",
    path: "/bladeball/ads",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/ads/index.vue")
  },
  {
    name: "bladeball-calculate",
    path: "/bladeball/calculate",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/calculate/index.vue")
  },
  {
    name: "bladeball-emotes",
    path: "/bladeball/emotes",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/emotes.vue")
  },
  {
    name: "bladeball-explosions",
    path: "/bladeball/explosions",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/explosions.vue")
  },
  {
    name: "bladeball",
    path: "/bladeball",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/index.vue")
  },
  {
    name: "bladeball-swords",
    path: "/bladeball/swords",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/swords.vue")
  },
  {
    name: "bladeball-value-changes",
    path: "/bladeball/value-changes",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/bladeball/value-changes.vue")
  },
  {
    name: "da-hood-ad-id",
    path: "/da-hood/ad/:id()",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/ad/[id].vue")
  },
  {
    name: "da-hood-ads-create",
    path: "/da-hood/ads/create",
    meta: indexFZK19nq6E3Meta || {},
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/ads/create/index.vue")
  },
  {
    name: "da-hood-ads",
    path: "/da-hood/ads",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/ads/index.vue")
  },
  {
    name: "da-hood-calculate",
    path: "/da-hood/calculate",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/calculate/index.vue")
  },
  {
    name: "da-hood",
    path: "/da-hood",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/index.vue")
  },
  {
    name: "da-hood-leak-id",
    path: "/da-hood/leak/:id()",
    meta: _91id_93VwD0BLRiwtMeta || {},
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/leak/[id].vue")
  },
  {
    name: "da-hood-leaks",
    path: "/da-hood/leaks",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/leaks.vue")
  },
  {
    name: "da-hood-skin-id",
    path: "/da-hood/skin/:id()",
    meta: _91id_93UPOTsvwxJtMeta || {},
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/skin/[id].vue")
  },
  {
    name: "da-hood-skins",
    path: "/da-hood/skins",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/skins.vue")
  },
  {
    name: "da-hood-value-changes",
    path: "/da-hood/value-changes",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/da-hood/value-changes.vue")
  },
  {
    name: "gpo-ad-id",
    path: "/gpo/ad/:id()",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/ad/[id].vue")
  },
  {
    name: "gpo-ads-create",
    path: "/gpo/ads/create",
    meta: indexaEWzgjHMCLMeta || {},
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/ads/create/index.vue")
  },
  {
    name: "gpo-ads",
    path: "/gpo/ads",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/ads/index.vue")
  },
  {
    name: "gpo-calculate",
    path: "/gpo/calculate",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/calculate/index.vue")
  },
  {
    name: "gpo",
    path: "/gpo",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/index.vue")
  },
  {
    name: "gpo-item-id",
    path: "/gpo/item/:id()",
    meta: _91id_93UALAIrEaXnMeta || {},
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/item/[id].vue")
  },
  {
    name: "gpo-items",
    path: "/gpo/items",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/items.vue")
  },
  {
    name: "gpo-value-changes",
    path: "/gpo/value-changes",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/gpo/value-changes.vue")
  },
  {
    name: "mm2-ad-id",
    path: "/mm2/ad/:id()",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/ad/[id].vue")
  },
  {
    name: "mm2-ads-create",
    path: "/mm2/ads/create",
    meta: indexhUpw0WiqqNMeta || {},
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/ads/create/index.vue")
  },
  {
    name: "mm2-ads",
    path: "/mm2/ads",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/ads/index.vue")
  },
  {
    name: "mm2-calculate",
    path: "/mm2/calculate",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/calculate/index.vue")
  },
  {
    name: "mm2",
    path: "/mm2",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/index.vue")
  },
  {
    name: "mm2-item-id",
    path: "/mm2/item/:id()",
    meta: _91id_93PEN4hTh2hrMeta || {},
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/item/[id].vue")
  },
  {
    name: "mm2-items",
    path: "/mm2/items",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/items.vue")
  },
  {
    name: "mm2-value-changes",
    path: "/mm2/value-changes",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/mm2/value-changes.vue")
  },
  {
    name: "ps-99-ad-id",
    path: "/ps-99/ad/:id()",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/ad/[id].vue")
  },
  {
    name: "ps-99-ads-create",
    path: "/ps-99/ads/create",
    meta: indexrFJf1iHJdlMeta || {},
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/ads/create/index.vue")
  },
  {
    name: "ps-99-ads",
    path: "/ps-99/ads",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/ads/index.vue")
  },
  {
    name: "ps-99-calculate",
    path: "/ps-99/calculate",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/calculate/index.vue")
  },
  {
    name: "ps-99",
    path: "/ps-99",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/index.vue")
  },
  {
    name: "ps-99-item-id",
    path: "/ps-99/item/:id()",
    meta: _91id_93Y4dwkxJ1f6Meta || {},
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/item/[id].vue")
  },
  {
    name: "ps-99-items",
    path: "/ps-99/items",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/items.vue")
  },
  {
    name: "ps-99-value-changes",
    path: "/ps-99/value-changes",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(games)/ps-99/value-changes.vue")
  },
  {
    name: "community-guidelines",
    path: "/community-guidelines",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(legal)/community-guidelines.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(legal)/privacy-policy.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/(legal)/terms.vue")
  },
  {
    name: "home",
    path: "/",
    meta: indexI6aHGDWrAdMeta || {},
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/home/index.vue")
  },
  {
    name: "staff",
    path: "/staff",
    component: () => import("/home/runner/work/web/web/apps/web/app/pages/staff.vue")
  }
]